import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { relationshipSummaryModel } from '~/models';
import { AutomaticFilterValue, BillingTriggerFilterValue, CompletionFilterValue, FilterType, HasAmendmentsFilterValue, HasCreditFilterValue, LastBillingDateType, PaymentMethodFilterValue, PriceIncreaseFilterValue, RecurrenceFilterValue } from '~/pages/AgreementsDashboard/agreementsDashboardFilters';
const STATUS_MAP = {
    active: relationshipSummaryModel.AgreementStatus.Active,
    amended: relationshipSummaryModel.AgreementStatus.Active,
    exhausted: relationshipSummaryModel.AgreementStatus.Exhausted,
    terminated: relationshipSummaryModel.AgreementStatus.Terminated
};
const PAYMENT_METHOD_MAP = {
    bank: PaymentMethodFilterValue.BankAccount,
    credit: PaymentMethodFilterValue.CreditCard,
    notSet: PaymentMethodFilterValue.NotSet,
    verificationInitiated: PaymentMethodFilterValue.VerificationInitiated,
    verificationFailed: PaymentMethodFilterValue.VerificationFailed
};
const HAS_CREDIT_MAP = {
    yes: HasCreditFilterValue.Yes,
    no: HasCreditFilterValue.No
};
const PRICE_INCREASE_MAP = {
    none: PriceIncreaseFilterValue.None,
    automatic: PriceIncreaseFilterValue.Automatic
};
const BILLED_UPON_TRIGGER_MAP = {
    ongoing: BillingTriggerFilterValue.Automatic,
    approval: BillingTriggerFilterValue.Automatic,
    oneTimeInStages: BillingTriggerFilterValue.Automatic,
    oneTimeManual: BillingTriggerFilterValue.Manual,
    oneTimeDelivery: BillingTriggerFilterValue.Manual,
    repeatableManual: BillingTriggerFilterValue.Manual,
    onDemand: BillingTriggerFilterValue.Manual
};
const BILLED_UPON_OCCURRENCE_MAP = {
    oneTimeManual: RecurrenceFilterValue.OneTime,
    oneTimeDelivery: RecurrenceFilterValue.OneTime,
    oneTimeInStages: RecurrenceFilterValue.OneTime,
    approval: RecurrenceFilterValue.OneTime,
    onDemand: RecurrenceFilterValue.OnDemand
};
const RECURRENCE_MAP = {
    weekly: RecurrenceFilterValue.Weekly,
    biweekly: RecurrenceFilterValue.Biweekly,
    monthly: RecurrenceFilterValue.Monthly,
    quarterly: RecurrenceFilterValue.Quarterly,
    yearly: RecurrenceFilterValue.Yearly
};
const COMPLETION_MAP = {
    completed: CompletionFilterValue.Completed,
    notCompleted: CompletionFilterValue.NotCompleted
};
const AUTOMATIC_STATE_MAP = {
    active: AutomaticFilterValue.Active,
    paused: AutomaticFilterValue.Paused
};
const mapStatus = (status)=>{
    if ((status === null || status === void 0 ? void 0 : status.in) == null) return {};
    return {
        [FilterType.AgreementStatus]: [
            ...new Set(status.in.map((value)=>STATUS_MAP[value]))
        ]
    };
};
const mapEffectiveDate = (effectiveDate)=>{
    if ((effectiveDate === null || effectiveDate === void 0 ? void 0 : effectiveDate.gte) == null && (effectiveDate === null || effectiveDate === void 0 ? void 0 : effectiveDate.lte) == null) return {};
    const value = _object_spread({}, effectiveDate.gte != null && {
        fromDate: new Date(effectiveDate.gte)
    }, effectiveDate.lte != null && {
        toDate: new Date(effectiveDate.lte)
    });
    return {
        [FilterType.EffectiveDate]: value
    };
};
const mapLastBilled = (lastBilled)=>{
    if (lastBilled == null) return {};
    if (lastBilled.exists === false) return {
        [FilterType.LastBillingDate]: {
            type: LastBillingDateType.Never
        }
    };
    if (lastBilled.gte != null && lastBilled.lte != null) {
        const range = {
            type: LastBillingDateType.Range,
            fromDate: new Date(lastBilled.gte),
            toDate: new Date(lastBilled.lte)
        };
        return {
            [FilterType.LastBillingDate]: range
        };
    }
    if (lastBilled.exists === true) return {
        [FilterType.LastBillingDate]: {
            type: LastBillingDateType.Ever
        }
    };
    return {};
};
const mapPaymentMethod = (paymentMethod)=>{
    if ((paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.in) == null) return {};
    return {
        [FilterType.PaymentMethod]: paymentMethod.in.map((value)=>PAYMENT_METHOD_MAP[value])
    };
};
const mapHasCredit = (hasCredit)=>{
    if ((hasCredit === null || hasCredit === void 0 ? void 0 : hasCredit.in) == null) return {};
    return {
        [FilterType.HasCredit]: hasCredit.in.map((value)=>HAS_CREDIT_MAP[value])
    };
};
const mapPriceIncrease = (automaticPriceIncrease)=>{
    if ((automaticPriceIncrease === null || automaticPriceIncrease === void 0 ? void 0 : automaticPriceIncrease.in) == null) return {};
    return {
        [FilterType.ServicePriceIncreaseState]: automaticPriceIncrease.in.map((value)=>PRICE_INCREASE_MAP[value])
    };
};
const mapAmendments = (amendmentStatus)=>{
    if ((amendmentStatus === null || amendmentStatus === void 0 ? void 0 : amendmentStatus.hasAmendments) == null) return {};
    return {
        [FilterType.HasAmendments]: [
            amendmentStatus.hasAmendments ? HasAmendmentsFilterValue.True : HasAmendmentsFilterValue.False
        ]
    };
};
const mapServices = (services)=>{
    var _ref, _ref1, _ref2, _ref3, _ref4;
    var _service_name, _service_name1, _service_name2, _service_name3, _service_recurrence, _service_billedUpon, _service_completionState, _service_automaticState, _service_billedUpon1;
    const service = services === null || services === void 0 ? void 0 : services.any;
    if (service == null) return {};
    const serviceName = (_ref = (_ref1 = (_ref2 = (_service_name = service.name) === null || _service_name === void 0 ? void 0 : _service_name.exact) !== null && _ref2 !== void 0 ? _ref2 : (_service_name1 = service.name) === null || _service_name1 === void 0 ? void 0 : _service_name1.contains) !== null && _ref1 !== void 0 ? _ref1 : (_service_name2 = service.name) === null || _service_name2 === void 0 ? void 0 : _service_name2.fuzzy) !== null && _ref !== void 0 ? _ref : (_service_name3 = service.name) === null || _service_name3 === void 0 ? void 0 : _service_name3.startsWith;
    const occurrence = [
        ...((_ref3 = (_service_recurrence = service.recurrence) === null || _service_recurrence === void 0 ? void 0 : _service_recurrence.in) !== null && _ref3 !== void 0 ? _ref3 : []).map((value)=>RECURRENCE_MAP[value]),
        ...((_ref4 = (_service_billedUpon = service.billedUpon) === null || _service_billedUpon === void 0 ? void 0 : _service_billedUpon.in) !== null && _ref4 !== void 0 ? _ref4 : []).map((value)=>BILLED_UPON_OCCURRENCE_MAP[value]).filter((value)=>value != null)
    ];
    return _object_spread({}, serviceName != null && {
        [FilterType.ServiceNames]: [
            serviceName
        ]
    }, ((_service_completionState = service.completionState) === null || _service_completionState === void 0 ? void 0 : _service_completionState.in) != null && {
        [FilterType.Completion]: service.completionState.in.map((value)=>COMPLETION_MAP[value])
    }, ((_service_automaticState = service.automaticState) === null || _service_automaticState === void 0 ? void 0 : _service_automaticState.in) != null && {
        [FilterType.Automatic]: service.automaticState.in.map((value)=>AUTOMATIC_STATE_MAP[value])
    }, ((_service_billedUpon1 = service.billedUpon) === null || _service_billedUpon1 === void 0 ? void 0 : _service_billedUpon1.in) != null && {
        [FilterType.BillingTrigger]: [
            ...new Set(service.billedUpon.in.map((value)=>BILLED_UPON_TRIGGER_MAP[value]))
        ]
    }, occurrence.length > 0 && {
        [FilterType.Recurrence]: [
            ...new Set(occurrence)
        ]
    });
};
export const filterToFixedControls = (filter)=>_object_spread({}, mapStatus(filter.status), mapEffectiveDate(filter.effectiveDate), mapLastBilled(filter.lastBilled), mapPaymentMethod(filter.paymentMethod), mapHasCredit(filter.hasCredit), mapPriceIncrease(filter.automaticPriceIncrease), mapAmendments(filter.amendmentStatus), mapServices(filter.services));
